import React from "react";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import { MultiPickerListProps } from "../props";
import { ProductionSublabel } from "./ProductionList";

const MultiProductionList = (props: MultiPickerListProps<server.dto.ProductionSmallV2>) => {
  const [instruction, setInstruction] = React.useState<server.dto.ListProductionInstruction>({
    page: 1,
    perPage: 20,
    keyword: "",
  });

  return <>
    <MultiPickerListWithSelectedItems
      instruction={instruction}
      onInstructionChange={i => setInstruction(i)}
      queryKey="productionpickerlist"
      api={window.CoreApi.Production.PaginatedSmall}

      getError={() => undefined}
      excludeKeys={props.excludeKeys}
      renderListItem={production => <div>
        <div>{production.name}</div>
        <ProductionSublabel production={production} />
      </div>}

      onChange={props.onChange}
      getId={(production) => production.productionId}
      getLabel={(production) => <div>{production.name}</div>}
      value={props.value}
    />
  </>;
};

export default MultiProductionList;